var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmileImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "42.000000pt",
    height: "44.000000pt",
    viewBox: "0 0 42.000000 44.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,44.000000) scale(0.100000,-0.100000)",
    fill: "inherit",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 374 c-13 -13 -16 -43 -16 -175 l0 -159 163 0 c113 0 167 4 175 12 8 8 12 62 12 175 l0 163 -159 0 c-132 0 -162 -3 -175 -16z m130 -123 c-10 -16 -36 -13 -43 5 -8 22 18 37 36 20 7 -8 10 -19 7 -25z m104 8 c0 -12 -7 -19 -19 -19 -22 0 -34 23 -19 38 15 15 38 3 38 -19z m-136 -84 c26 -20 100 -19 130 1 18 11 26 12 31 4 24 -39 -113 -67 -173 -36 -32 16 -38 26 -25 39 9 10 15 8 37 -8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileImg);
export default __webpack_public_path__ + "static/media/smileImg.03a1b32fd7c653b0b2174185943fc5ab.svg";
export { ForwardRef as ReactComponent };